// Definición central de las 3 unidades de negocio CelebraGroup.
// Cada catálogo (servicios, paquetes, menús, recetas) puede llevar el campo `unidad` con uno de estos slugs.
// Los dashboards y la pantalla de selección consumen estos colores/labels.

import { Building2, Sparkles, ChefHat } from "lucide-react";

export const UNIDADES = [
  {
    slug: "petit",
    nombre: "Celebra Petit",
    descripcion_corta: "Renta de instalaciones",
    descripcion_larga: "Renta el salón, alberca, jardín, terraza y disfruta de nuestro espacio.",
    icon: Building2,
    color: "#16a34a",        // verde
    color_soft: "#dcfce7",
    color_dark: "#166534",
    cta: "Ver disponibilidad",
    bullets: ["Salón climatizado", "Alberca y jardín", "Terraza y áreas comunes", "Mobiliario incluido"],
    panel_path: "/panel/petit",
    publico_path: "/contratar/petit",
  },
  {
    slug: "kermesita",
    nombre: "La Kermesita",
    descripcion_corta: "Planeación de eventos",
    descripcion_larga: "Organizamos y decoramos tu evento como siempre lo soñaste.",
    icon: Sparkles,
    color: "#db2777",        // rosa
    color_soft: "#fce7f3",
    color_dark: "#9d174d",
    cta: "Diseñar mi evento",
    bullets: ["Decoración personalizada", "Animación y actividades", "Coordinación integral", "Experiencias únicas"],
    panel_path: "/panel/kermesita",
    publico_path: "/contratar/kermesita",
  },
  {
    slug: "bocatto",
    nombre: "Bocatto Catering",
    descripcion_corta: "Alimentos y bebidas",
    descripcion_larga: "Catering a domicilio o en tu evento con la mejor calidad.",
    icon: ChefHat,
    color: "#ea580c",        // naranja
    color_soft: "#ffedd5",
    color_dark: "#9a3412",
    cta: "Ver menús",
    bullets: ["Menús para todos los gustos", "Catering corporativo y social", "Bebidas y postres", "Carritos y estaciones"],
    panel_path: "/panel/bocatto",
    publico_path: "/contratar/bocatto",
  },
];

export const getUnidad = (slug) => UNIDADES.find(u => u.slug === slug) || null;
